/*
 * Copyright Camunda Services GmbH and/or licensed to Camunda Services GmbH under
 * one or more contributor license agreements. See the NOTICE file distributed
 * with this work for additional information regarding copyright ownership.
 * Licensed under the Camunda License 1.0. You may not use this file
 * except in compliance with the Camunda License 1.0.
 */

import { observer } from 'mobx-react';

import { licenseStore } from 'stores';

import TopBarCommon from './TopBar.common';

const TopBar = ({ isInShare }) => {
  const notInShareMode = isInShare !== true;
  const { isCommercialLicense, isDeveloperLicense, expiresAt } = licenseStore;

  return (
    // @ts-expect-error TS2741
    <TopBarCommon
      showAppBar={false}
      showOrganizations={false}
      showCookiePreferences={false}
      showInfoBar={notInShareMode}
      showUserBar={notInShareMode}
      licenseTag={{
        show: notInShareMode,
        isProductionLicense: !isDeveloperLicense,
        isCommercial: isCommercialLicense,
        expiresAt
      }}
    />
  );
};

TopBar.Breadcrumbs = TopBarCommon.Breadcrumbs;
TopBar.SubHeader = TopBarCommon.SubHeader;

export default observer(TopBar);
